import { render, staticRenderFns } from "./SalesView.vue?vue&type=template&id=28de2b4d&scoped=true"
import script from "./SalesView.vue?vue&type=script&lang=ts"
export * from "./SalesView.vue?vue&type=script&lang=ts"
import style0 from "./SalesView.vue?vue&type=style&index=0&id=28de2b4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28de2b4d",
  null
  
)

export default component.exports